import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { useLocale } from '../context/LocaleContext';
import { useIntersectionReveal } from '../hooks/useIntersectionReveal';
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { contact } from "../apis/inquiries";
export const ContactSection = () => {
    const { t } = useLocale();
    const ref = useIntersectionReveal();
    const [status, setStatus] = useState('');
    const [error, setError] = useState(false);
    const { executeRecaptcha } = useGoogleReCaptcha();
    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
            return null;
        }
        try {
            const token = await executeRecaptcha('contact_form');
            return token ?? null;
        }
        catch (e) {
            return null;
        }
    }, [executeRecaptcha]);
    async function handleSubmit(e) {
        e.preventDefault();
        const form = e.currentTarget;
        const fd = new FormData(form);
        const name = fd.get('name')?.toString().trim();
        const email = fd.get('email')?.toString().trim();
        const message = fd.get('message')?.toString().trim();
        if (!name || !email || !message) {
            setStatus(t('contact.status.required'));
            setError(true);
            return;
        }
        setStatus(t('contact.status.verifying'));
        const token = await handleReCaptchaVerify();
        if (!token) {
            setStatus(t('contact.status.verifyFailed'));
            setError(true);
            return;
        }
        setError(false);
        setStatus(t('contact.status.sending'));
        const data = {
            name,
            email,
            message,
            recaptchaToken: token,
        };
        contact(data).then(() => {
            setStatus(t('contact.status.sent'));
            setError(false);
            form.reset();
        }).catch((err) => {
            console.error('Contact form submission error:', err);
            setStatus(t('contact.status.failed'));
            setError(true);
        });
    }
    return (_jsxs("section", { id: "contact", ref: ref, className: "contact-section", children: [_jsx("h2", { children: t('contact.title') }), _jsx("p", { children: t('contact.desc') }), _jsxs("form", { onSubmit: handleSubmit, className: "contact-form", noValidate: true, children: [_jsxs("label", { children: [t('contact.name'), _jsx("input", { name: "name", type: "text", placeholder: "\u5C71\u7530 \u592A\u90CE / John Smith", required: true })] }), _jsxs("label", { children: [t('contact.email'), _jsx("input", { name: "email", type: "email", placeholder: "you@example.com", required: true })] }), _jsxs("label", { children: [t('contact.message'), _jsx("textarea", { name: "message", rows: 5, placeholder: "\u5728\u5EAB\u306B\u3064\u3044\u3066...", required: true })] }), _jsx("button", { type: "submit", className: "btn neon", children: t('contact.submit') }), _jsx("div", { className: `form-status ${error ? 'error' : ''}`, "aria-live": "polite", children: status })] })] }));
};
